export default {
  user_pk: localStorage.getItem("user-pk") || "",
  user_search: localStorage.getItem("user-search") || "",
  user_profile: undefined,
  currency: localStorage.getItem("user-currency") || "GBP",
  policy: localStorage.getItem("user-policy") || "all",
  policies: ["all"],
  hasPortfolio: true,
};
